const actionColors = [
    {
        action: "Positive",
        color: "#059669",
    },
    {
        action: "Negative",
        color: "#dc2626",
    },
    {
        action: "NA",
        color: "#2657dc",
    },
    {
        action: "Pending",
        color: "#d97706",
    },
]

const actionFinder = (item) => {
    const action = item?.action === "YES" ? "Positive" : item?.action === "NO" ? "Negative" : item?.action === "NA" ? "NA" : "Pending"
    const actionColor = actionColors.find((color) => color.action === action)?.color
    return {
        action: action,
        color: actionColor
    }
}

export default actionFinder;